class scrollUpNavMobile {
  constructor() {
    const lastScrollTop = 0;
    this.handleScroll(lastScrollTop);
  }

  handleScroll(lastScrollTop) {
    document.addEventListener('scroll', () => {
      this.scrollTop = document.documentElement.scrollTop;
      const currentScrollTop = window.scrollY || this.scrollTop;

      if (currentScrollTop > lastScrollTop || currentScrollTop === 0) {
        if (document.querySelector('.show-sticky-nav-mobile')) {
          document.querySelector('body').classList.remove('show-sticky-nav-mobile');
        }
        if (document.querySelector('.show-sticky-nav-mobile-for-blog')) {
          document.querySelector('body').classList.remove('show-sticky-nav-mobile-for-blog');
        }
      } else {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
          document.querySelector('body').classList.remove('show-sticky-nav-mobile');
          document.querySelector('body').classList.remove('show-sticky-nav-mobile-for-blog');
        } else {
          if (
            window.location.pathname !== '/blog/' &&
            window.location.pathname.includes('/blog/')
          ) {
            document.querySelector('body').classList.add('show-sticky-nav-mobile');
            document.querySelector('body').classList.add('show-sticky-nav-mobile-for-blog');
          } else {
            document.querySelector('body').classList.add('show-sticky-nav-mobile');
          }
        }
      }
      lastScrollTop = currentScrollTop;
    });
  }
}
export default scrollUpNavMobile;
